export function inflect(input, count) {
  if (count === 1) {
    return input;
  } else {
    return `${input}s`;
  }
}

export function capitalizeFirstLetter(input) {
  return `${input.charAt(0).toUpperCase()}${input.slice(1)}`;
}

export function splitAt(index, str) {
  return [str.slice(0, index), str.slice(index)];
}

export function appendCopy(str, existing = [], maxLength) {
  const match = str.match(/^(.*?)(?: copy(?: (\d+))?)?$/);
  const rawBase = match[1].trim();

  const escapeRegex = (s) => s.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');

  let finalBase = '';
  let maxNum = 0;

  // Try different base truncations to fit suffixes
  for (let i = 0; i < 100; i++) {
    const suffix = i === 0 ? ' copy' : ` copy ${i + 1}`;

    // Ensure maxLength can accommodate at least the suffix
    if (maxLength < suffix.length) {
      return rawBase.slice(0, Math.max(1, maxLength - suffix.length)) + suffix.slice(0, maxLength - 1);
    }

    const base = rawBase.slice(0, maxLength - suffix.length);

    // Build regex to match this base's existing copies
    const basePattern = new RegExp(`^${escapeRegex(base)}(?: copy(?: (\\d+))?)?$`);

    // Find max number used for this truncated base
    const nums = existing
      .map((name) => {
        const m = name.match(basePattern);
        if (m) return m[1] ? +m[1] : 1;
      })
      .filter((n) => n !== undefined);

    maxNum = nums.length ? Math.max(...nums) : 0;
    finalBase = base;

    // Once we have a base that can accept suffix and fit within limit, break
    if (finalBase.length + (maxNum === 0 ? 5 : ` copy ${maxNum + 1}`.length) <= maxLength) {
      break;
    }
  }

  const suffix = maxNum === 0 ? ' copy' : ` copy ${maxNum + 1}`;
  return finalBase + suffix;
}
